import classNames from 'classnames';
import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

type Props = {
    /**
     * @default true
     */
    withOwnText?: boolean;
    /**
     * @default false;
     */
    withReceiptField?: boolean;
    /**
     * @default false
     */
    eightCol?: boolean;
    titleClassName?: string;
};
const TransactionFormSkeleton: React.FC<Props> = ({
    withOwnText = true,
    withReceiptField = false,
    eightCol = false,
    titleClassName,
}) => (
    <>
        {titleClassName && (
            <div className={titleClassName}>
                <h2>
                    <DarkSkeleton height={40} width={200} />
                </h2>
            </div>
        )}
        <div className={classNames('transaction-form active skeleton', { 'eight-col': eightCol })}>
            <div className="from-account-select transaction-form__from-account-selector">
                <DarkSkeleton height={90} width="100%" />
            </div>
            <div className="from-account-select transaction-form__to-account-selector">
                <DarkSkeleton height={90} width="100%" />
            </div>
            <div className="amount-input__container transaction-form__amount-selector">
                <DarkSkeleton height={24} width={46} />
                <DarkSkeleton height={48} width="100%" />
            </div>
            <div className="message-field transaction-form__message-selector">
                <DarkSkeleton height={24} width={46} />
                <DarkSkeleton height={48} width="100%" />
            </div>
            <div className="transaction-form__date-selector">
                <DarkSkeleton height={24} width={46} />
                <DarkSkeleton height={48} width="100%" />
            </div>
            {withOwnText && (
                <div className="owntext-selector__wrapper transaction-form__owntext-selector">
                    <DarkSkeleton height={24} width={150} />
                </div>
            )}
            {withReceiptField && (
                <div className="owntext-selector__wrapper transaction-form__owntext-selector">
                    <DarkSkeleton height={24} width={150} />
                </div>
            )}
            <div className="payment-item__button-row transaction-form__submit">
                <DarkSkeleton height={40} width={80} style={{ borderRadius: 24 }} />
            </div>
        </div>
    </>
);

export default TransactionFormSkeleton;
